interface Point {
  x: number
  y: number
}

// Class for cubic bezier curve. Look at https://cubic-bezier.com/#.17,.67,.86,.39
class CubicBezierCurve {
  private start: Point
  private controlPoint1: Point
  private controlPoint2: Point
  private end: Point

  public constructor(start: Point, controlPoint1: Point, controlPoint2: Point, end: Point) {
    this.start = start
    this.controlPoint1 = controlPoint1
    this.controlPoint2 = controlPoint2
    this.end = end
  }

  private static B3(t: number): number {
    return t * t * t
  }
  private static B2(t: number): number {
    return 3 * t * t * (1 - t)
  }
  private static B1(t: number): number {
    return 3 * t * (1 - t) * (1 - t)
  }
  private static B0(t: number): number {
    return (1 - t) * (1 - t) * (1 - t)
  }

  /**
   * Cubic bezier curve function:
   * B(t) = (1-t)^3 * P0 + 3(1-t)^2* t* P1 + 3(1-t)t^2 *P2 + t^3 *P3
   * @param start starting point
   * @param end ending point
   * @param location in range 0-1, 0 is the start and 1 is the end
   */
  public getPointOnBezierCurve(location: number): Point {
    const t = location
    const x =
      CubicBezierCurve.B0(t) * this.start.x +
      CubicBezierCurve.B1(t) * this.controlPoint1.x +
      CubicBezierCurve.B2(t) * this.controlPoint2.x +
      CubicBezierCurve.B3(t) * this.end.x
    const y =
      CubicBezierCurve.B0(t) * this.start.y +
      CubicBezierCurve.B1(t) * this.controlPoint1.y +
      CubicBezierCurve.B2(t) * this.controlPoint2.y +
      CubicBezierCurve.B3(t) * this.end.y
    return { x, y }
  }

  // Cubic bezier curves have two control points
  public get controlPoints(): [Point, Point] {
    return [this.controlPoint1, this.controlPoint2]
  }
}

class SimpleCubicBezierCurve extends CubicBezierCurve {
  /**
   * @param start starting point
   * @param end ending point
   * @param [curviness=1] measure how curvy the line will be, where 0 will be a straight line
   */
  public constructor(start: Point, end: Point, curviness = 0.5) {
    const xDistance = end.x - start.x
    const yDistance = end.y - start.y
    const cp1 = { ...start }
    const cp2 = { ...end }
    // if (Math.abs(xDistance) > Math.abs(yDistance)) {
    cp1.y += yDistance * curviness * 0.8 + xDistance * curviness * 0.2
    cp2.y -= yDistance * curviness * 0.8 + xDistance * curviness * 0.2
    cp1.x -= yDistance * curviness * 0.1
    cp2.x += yDistance * curviness * 0.1
    // } else {
    //   cp1.x += xDistance * curviness * 0.9 + yDistance * curviness * 0.1
    //   cp2.x -= xDistance * curviness * 0.9 + yDistance * curviness * 0.1
    //   cp1.y -= (xDistance) * curviness * 0.05
    //   cp2.y += (xDistance) * curviness * 0.05
    // }
    super(start, cp1, cp2, end)
  }
}

export { Point, CubicBezierCurve, SimpleCubicBezierCurve }
